import { render } from "./VideoContainerComponent.vue?vue&type=template&id=d1ed826a&scoped=true"
const script = {}

import "./VideoContainerComponent.vue?vue&type=style&index=0&id=d1ed826a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ed826a"]])

export default __exports__